import type { ReactNode } from 'react';
import { cn } from '../cn';
import { BuildStamp } from './build-stamp';
import { useHeaderActions } from './header-actions';
import s from './public-shell.module.css';

export function PublicShell({ children, narrow }: { children: ReactNode; narrow?: boolean }) {
  const actions = useHeaderActions();
  return (
    <>
      <header className={s['bar-top']}>
        <span className={s.brand}>Concord</span>
        <span className={s.cen}>Cancer Expert Now</span>
        {actions && <span className={s.actions}>{actions}</span>}
      </header>
      <div className={cn(s.wrap, narrow && s.narrow)}>
        {children}
        <BuildStamp />
      </div>
    </>
  );
}
